"use client";

import Link from "next/link";

export const LinkWrapper = ({
    children,
    href,
    openInNewTab = false,
    className,
}: {
    children: React.ReactNode;
    href: string;
    openInNewTab?: boolean;
    className?: string;
}) => {
    const isInternalLink = href.startsWith("/");

    if (href.includes("null")) {
        return <div className={className}>{children}</div>;
    }

    return (
        <Link
            href={href}
            target={openInNewTab ? "_blank" : "_self"}
            rel={
                openInNewTab && !isInternalLink
                    ? "noopener noreferrer"
                    : undefined
            }
            className={className}
        >
            {children}
        </Link>
    );
};
